import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-primary" data-id="element-71">
      {/* Background Glow */}
      <div className="absolute bottom-0 left-0 w-[800px] h-[800px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(255,107,0,0.15) 0%, transparent 60%)',
      transform: 'translate(-30%, 30%)'
    }} data-id="element-72" />

      <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none" data-id="element-73" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full py-12 lg:py-0" data-id="element-74">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-8" data-id="element-75">
          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-[60%] flex flex-col items-start" data-id="element-76">
            <div className="inline-flex items-center px-4 py-1.5 rounded-full border border-accent/40 bg-accent/10 mb-8" data-id="element-77">
              <span className="text-sm font-medium text-white" data-id="element-78">
                🔥 Solo para Dueños Gastronómicos buscando más clientes
              </span>
            </div>

            <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-black text-white leading-[1.1] mb-6 tracking-tight" data-id="element-79">
              Sistema de Demanda Sostenida
            </h1>

            <h2 className="text-2xl sm:text-3xl font-bold text-gradient mb-6 leading-tight" data-id="element-80">
              La ingeniería diseñada para escalar tu facturación
            </h2>

            <p className="text-text-secondary text-lg sm:text-xl max-w-2xl mb-10 leading-relaxed" data-id="element-81">
              Fusionamos marketing gastronómico y anuncios digitales
              inteligentes para generar resultados drásticos. Como dueño de
              restaurante, entiendo el negocio desde adentro. Escalé mi propia
              facturación de 3.500 a 35.000 USD en 90 días.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-82">
              <a href="#agendar" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold rounded-xl text-white bg-accent glow-button w-full sm:w-auto" data-id="element-83">
                Quiero escalar mi negocio
              </a>
              <a href="#el-sistema" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold rounded-xl text-white bg-transparent border-2 border-accent hover:bg-accent transition-colors duration-300 w-full sm:w-auto" data-id="element-84">
                Ver el sistema
              </a>
            </div>
          </motion.div>

          {/* Right Column */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full lg:w-[40%] flex flex-col items-center lg:items-end" data-id="element-85">
            <div className="relative w-full max-w-md" data-id="element-86">
              <div className="absolute inset-0 rounded-2xl" style={{
              boxShadow: '0 0 40px rgba(255,107,0,0.3)'
            }} data-id="element-87" />
              <img src="https://cdn.magicpatterns.com/uploads/sNii9TDa4EnJcjDtTLJv1s/WhatsApp_Image_2026-05-21_at_11.05.45_AM.jpg" alt="Joaquín González Paredes" className="relative z-10 w-full h-[500px] object-cover object-top rounded-2xl border border-white/10" data-id="element-88" />
              <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-[90%] bg-[#111] border border-white/10 rounded-xl p-4 text-center z-20 shadow-2xl backdrop-blur-sm" data-id="element-89">
                <h3 className="font-bold text-white text-lg" data-id="element-90">
                  Joaquín González Paredes
                </h3>
                <p className="text-accent text-sm font-medium mt-1" data-id="element-91">
                  Estratéga Gastronómico
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}